const SITE_ID = 32;const SITE_UID='91b8defb-aebf-45e1-9590-339b9b9d5fad';const SUBDOMAIN='yj';export { SITE_ID, SITE_UID, SUBDOMAIN }